var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.388 0 0 22.396 0 50c0 27.62 22.388 50 50 50s50-22.38 50-50c0-27.604-22.388-50-50-50Zm0 90.323C27.715 90.323 9.677 72.293 9.677 50 9.677 27.723 27.717 9.677 50 9.677c22.276 0 40.323 18.039 40.323 40.323S72.293 90.323 50 90.323Zm8.468-20.968c0 4.669-3.799 8.468-8.468 8.468-4.67 0-8.468-3.799-8.468-8.468 0-4.67 3.799-8.468 8.468-8.468 4.67 0 8.468 3.799 8.468 8.468ZM42.062 26.734l1.371 27.419a2.42 2.42 0 0 0 2.417 2.299h8.3a2.42 2.42 0 0 0 2.417-2.299l1.37-27.42a2.42 2.42 0 0 0-2.416-2.54H44.48a2.42 2.42 0 0 0-2.416 2.54Z",
    fill: "#CA1F18",
    fillRule: "nonzero"
  })));
};

export default SvgExclamationCircle;